import { fetchV3TroubleshootTimes } from '../../api/troubleshootAPI';
import getIn from 'transmute/getIn';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
export const requestTroubleshootTimes = () => ({
  type: ActionTypes.REQUEST_TROUBLESHOOT_TIMES
});
export const receiveTroubleshootTimes = data => ({
  type: ActionTypes.RECEIVE_TROUBLESHOOT_TIMES,
  data
});
export const requestTroubleshootTimesRejected = err => ({
  type: ActionTypes.REQUEST_TROUBLESHOOT_TIMES_REJECTED,
  err
});
export const updateTroubleshootTimes = data => ({
  type: ActionTypes.UPDATE_TROUBLESHOOT_TIMES,
  data
});
export const fetchTroubleshootTimes = () => (dispatch, getState) => {
  const slug = getState().userSlug;
  const timezone = getState().userTimezone;
  const contactEmail = getState().emailFormState;
  const portalId = getIn(['bookInfo', 'portalId'])(getState());
  dispatch(requestTroubleshootTimes());
  return fetchV3TroubleshootTimes({
    // @ts-ignore fix type
    slug,
    // @ts-ignore fix type
    portalId,
    timezone,
    contactEmail
  }).then(response => dispatch(receiveTroubleshootTimes(response))).catch(err => dispatch(requestTroubleshootTimesRejected(err)));
};